/**
 * Sidebar entries this server leaves out. The pages themselves stay
 * reachable by their address (and hashtags can still be followed); only
 * the navigation no longer offers them.
 */
export const navigationShows: Record<
  'followedTags' | 'trends' | 'liveFeeds' | 'explore',
  boolean
> = {
  /** The list of followed hashtags */
  followedTags: false,
  /** The "Trending now" hashtags under the navigation */
  trends: false,
  /** The link to the live feeds */
  liveFeeds: false,
  /** The "Trending" (Explore) link; search stays in the search box */
  explore: false,
};
